/* jshint esversion: 6 */
import React from 'react';
import PropTypes from 'prop-types';

class ReactivateRoute extends React.Component {
	constructor(props) {
		super(props);

		let constants = this.props.app.config.constants;

		this.state = {
			checked: constants.FIRSTPULL_SINGLE
		};

		this.setNextPostValue = this.setNextPostValue.bind(this);
		this.onFinish = this.onFinish.bind(this);
	}

	setNextPostValue(event) {
		let newValue = event.currentTarget.value;

		this.setState({
			checked: newValue
		});

		this.props.onRadioClick.apply(this, [newValue, event]);
	}

	onFinish(event) {
		event.preventDefault();
		this.props.onRadioClick.apply(this, [this.state.checked, event])
		this.props.onFinish.apply(this, [event]);
	}

	render() {
		let constants = this.props.app.config.constants,
			preposition = (parseInt(this.props.app.flags.routeViewType, 10) === constants.ROUTE_VIEW_SIMPLE) ? 'this' : 'each';

		return (
			<div className="route-reactivation">
				<div className="form-section">
					<div className="form-section-title">
						Post new items?
					</div>
					<label className="form-inline-control">
						<input id="first-pull-single" type="radio" className="form-inline-radio" checked={this.state.checked == constants.FIRSTPULL_SINGLE} value={constants.FIRSTPULL_SINGLE} name="next-post" onChange={this.setNextPostValue}/>
						<span className="form-inline-label">
							Share the most recent new item from {preposition} feed
						</span>
					</label>
					<label className="form-inline-control">
						<input id="first-pull-on" type="radio" className="form-inline-radio" checked={this.state.checked == constants.FIRSTPULL_ON} value={constants.FIRSTPULL_ON} name="next-post" onChange={this.setNextPostValue}/>
						<span className="form-inline-label">
							Share all the new items we find in {preposition} feed
						</span>
					</label>
					<label className="form-inline-control">
						<input id="first-pull-off" type="radio" className="form-inline-radio" checked={this.state.checked == constants.FIRSTPULL_OFF} value={constants.FIRSTPULL_OFF} name="next-post" onChange={this.setNextPostValue}/>
						<span className="form-inline-label">
							Wait until next new item to share
						</span>
					</label>
				</div>
				<div className="form-section">
					<div className="form-buttons">
						<button className="form-button" onClick={this.onFinish}>Done</button>
					</div>
				</div>
			</div>
		);
	}
};

ReactivateRoute.displayName = "ReactivateRoute";

ReactivateRoute.propTypes = {
	route: PropTypes.object,
	onRadioClick: PropTypes.func,
	onFinish: PropTypes.func
};

ReactivateRoute.defaultProps = {
	route: {},
	onRadioClick: null,
	onFinish: null
};

export default ReactivateRoute;
